
import { defaultOf } from "../fable_modules/fable-library-js.5.13.0/Util.js";

export function installBeforeUnloadWarning(model) {
    if (model.CurrentProj != null) {
        window.onbeforeunload = ((ev) => {
            ev.preventDefault();
            ev.returnValue = "";
            return "";
        });
    }
    else {
        window.onbeforeunload = defaultOf();
    }
}

